import { PropTypes } from 'prop-types'

const AuthFromWrapper = ({ children }) => {
  return (
    <main className="flex-grow flex items-center justify-center">
      <div className="vizops-auth container max-w-md">{children}</div>
    </main>
  )
}
AuthFromWrapper.propTypes = {
  children: PropTypes.node,
}
export default AuthFromWrapper
